import Layout from "../common/Layout";

function App() {
  return <Layout />;
}

export default App;
